import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ThemeContext } from '../../context/ThemeContext';
import { API_URL } from '../../utils/api';
//import { isPasswordValid } from '../../components/Auth/PasswordRules';
//import PasswordChecklist from '../../components/Auth/PasswordChecklist'; 
import { isPasswordValid } from '../../utils/passwordRules';
import PasswordChecklist from '../../components/Auth/PasswordChecklist';
import {
  DEFAULT_IMG,
  PageWrapper, Card, SectionTitle, HeaderCard,
  UserInfo, AvatarWrapper, AvatarImg, AvatarEditOverlay, AvatarPresetGrid, AvatarPresetBtn, UserMeta, UserName, UserEmail,
  TipoBadge, HeaderActions, RankingPanel, RankBadge, RankIcon, RankInfo,
  RankLabel, RankValue, BodyGrid, FormGroup, TwoCol, Label, Input, Select,
  Btn, ProtectedScreen, LockIcon, ProtectedTitle, ProtectedSub,
  DatosGrid, ImgSlot, ImgSlotImg, ImgSlotLabel, TooltipWrap,
} from './Profile.styles';

const TIPOS_VIA = [
  'Calle', 'Avenida', 'Paseo', 'Plaza', 'Carretera',
  'Autovía', 'Autopista', 'Camino', 'Ronda', 'Travesía',
  'Vía', 'Callejón', 'Bulevar',
];

// Construye la URL de una imagen servida por el backend, sin duplicar el
// dominio si la ruta ya viene absoluta (y corrigiendo el host si viene mal).
function buildBackendImgUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) {
    try {
      const u = new URL(path);
      const api = new URL(API_URL);
      u.protocol = api.protocol;
      u.host = api.host;
      return u.toString();
    } catch {
      return path;
    }
  }
  return `${API_URL}${path}`;
}

function Profile({ user, onLogout, onUserUpdate }) {
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const bg  = theme.modalBg;
  const acc = theme.accent;

  // Título gestionado por Helmet
  const [isEditing, setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState(() => {
    const defaults = {
      nombre: user?.name || '', telefono: '', tipoUsuario: 'persona',
      personaContacto: '', tipoVia: 'Calle', nombreVia: '', numero: '',
      piso: '', puerta: '', codigoPostal: '', pais: 'España', trasteroImg: null,
    };
    if (!user) return defaults;
    try {
      const saved = localStorage.getItem(`userProfile_${user.id}`);
      if (saved) return JSON.parse(saved);
    } catch {}
    return defaults;
  });
  const [draft, setDraft] = useState(profileData);
  const [ranking] = useState({ vendidos: 0, reclamaciones: 0, devueltos: 0, recomendados: 0 });
  const [trasteroNombre, setTrasteroNombre] = useState('');
  const [trasteroId,     setTrasteroId]     = useState(null);
  const [draftTrastero,  setDraftTrastero]  = useState('');
  const [trasteroError,  setTrasteroError]  = useState('');
  const [vigencia,       setVigencia]       = useState(null);
  const [avatarOpciones,      setAvatarOpciones]      = useState([]);
  const [avatarUploading,     setAvatarUploading]     = useState(false);
  const [trasteroImgUrl,      setTrasteroImgUrl]      = useState(null);
  const [trasteroImgUploading,setTrasteroImgUploading]= useState(false);
  const [passModal,     setPassModal]     = useState(false);
  const [passActual,    setPassActual]    = useState('');
  const [passNueva,     setPassNueva]     = useState('');
  const [passNueva2,    setPassNueva2]    = useState('');
  const [showPassA,     setShowPassA]     = useState(false);
  const [showPassN,     setShowPassN]     = useState(false);
  const [showPassN2,    setShowPassN2]    = useState(false);
  const [passError,     setPassError]     = useState('');
  const [passOk,        setPassOk]        = useState(false);
  const [passLoading,   setPassLoading]   = useState(false);

  const [bajaModal,      setBajaModal]      = useState(false);
  const [bajaEnvio,      setBajaEnvio]      = useState('idle');
  const [bajaPendiente,  setBajaPendiente]  = useState(false);

  useEffect(() => {
    if (!user) return;
    const token = localStorage.getItem('trastero_token');
    fetch(`${API_URL}/api/auth/estado`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setBajaPendiente(d.estado === 'baja_pendiente'); })
      .catch(() => {});
  }, [user]);

  useEffect(() => {
    if (!user) return;
    const token = localStorage.getItem('trastero_token');
    fetch(`${API_URL}/api/auth/foto-trastero`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.foto_trastero) setTrasteroImgUrl(d.foto_trastero); })
      .catch(() => {});
  }, [user]);

  useEffect(() => {
    if (!user) return;
    const token = localStorage.getItem('trastero_token');
    fetch(`${API_URL}/api/trasteros/contenedor?usuario_id=${user.id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.ok ? r.json() : [])
      .then(data => {
        if (data.length > 0) {
          setTrasteroNombre(data[0].nombre);
          setDraftTrastero(data[0].nombre);
          setTrasteroId(data[0].id);
          setVigencia(data[0]);
        }
      })
      .catch(() => {});
  }, [user]);

  if (!user) {
    return (
      <PageWrapper>
        <ProtectedScreen>
          <LockIcon>🔒</LockIcon>
          <ProtectedTitle bg={theme.background}>Acceso restringido</ProtectedTitle>
          <ProtectedSub bg={theme.background}>
            Necesitas iniciar sesión para ver tu perfil.
          </ProtectedSub>
          <Btn variant="primary" accent={acc} onClick={() => navigate('/')}>
            Ir al inicio
          </Btn>
        </ProtectedScreen>
      </PageWrapper>
    );
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDraft(prev => ({ ...prev, [name]: value }));
  };

  const handleEdit = () => {
    setDraft(profileData);
    setDraftTrastero(trasteroNombre);
    setIsEditing(true);
    if (avatarOpciones.length === 0) {
      fetch(`${API_URL}/api/auth/avatar/opciones`)
        .then(r => r.json())
        .then(setAvatarOpciones)
        .catch(() => {});
    }
  };

  const handleCancel = () => {
    setDraft(profileData);
    setDraftTrastero(trasteroNombre);
    setIsEditing(false);
  };

  const handleSave = async () => {
    setProfileData(draft);
    localStorage.setItem(`userProfile_${user.id}`, JSON.stringify(draft));
    const token = localStorage.getItem('trastero_token');

    if (draft.nombre.trim() && draft.nombre.trim() !== user.name) {
      try {
        const res = await fetch(`${API_URL}/api/auth/nombre`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ nombre: draft.nombre.trim() }),
        });
        if (res.ok && onUserUpdate) onUserUpdate({
          ...user,
          name:   draft.nombre.trim(),
          avatar: buildBackendImgUrl(user.avatar), // preservar avatar actual sin degradarlo
        });
      } catch {}
    }

    setTrasteroError('');
    if (draftTrastero.trim() && draftTrastero.trim() !== trasteroNombre && trasteroId) {
      try {
        const res = await fetch(`${API_URL}/api/trasteros/contenedor/${trasteroId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ nombre: draftTrastero.trim() }),
        });
        const data = await res.json();
        if (res.ok) {
          setTrasteroNombre(draftTrastero.trim());
        } else {
          setTrasteroError(data.error || 'No se pudo actualizar el nombre del trastero');
          return; // no cerrar edición si falló, para que el usuario pueda corregir
        }
      } catch {
        setTrasteroError('Error de conexión al actualizar el nombre del trastero');
        return;
      }
    }

    setIsEditing(false);
  };  

  const handleImgChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const token = localStorage.getItem('trastero_token');
    const formData = new FormData();
    formData.append('foto', file);
    setTrasteroImgUploading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/foto-trastero`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      if (res.ok) {
        const data = await res.json();
        setTrasteroImgUrl(data.foto_trastero);
      }
    } catch {}
    setTrasteroImgUploading(false);
    e.target.value = '';
  };

  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const token = localStorage.getItem('trastero_token');
    const formData = new FormData();
    formData.append('avatar', file);
    setAvatarUploading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/avatar`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      if (res.ok) {
        const data = await res.json();
        if (onUserUpdate) onUserUpdate({ ...user, avatar: buildBackendImgUrl(data.avatar_url) });
      }
    } catch {}
    setAvatarUploading(false);
    e.target.value = '';
  };

  const handlePresetAvatar = async (seed) => {
    const token = localStorage.getItem('trastero_token');
    try {
      const res = await fetch(`${API_URL}/api/auth/avatar/preset`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ seed }),
      });
      if (res.ok) {
        const data = await res.json();
        if (onUserUpdate) onUserUpdate({ ...user, avatar: buildBackendImgUrl(data.avatar_url) });
      }
    } catch {}
  };

  const handleLogout = () => {
    if (onLogout) onLogout();
    navigate('/');
  };

  const handleBaja = async () => {
    setBajaEnvio('loading');
    try {
      const token = localStorage.getItem('trastero_token');
      const res = await fetch(`${API_URL}/api/auth/baja`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error();
      setBajaPendiente(true);
      setBajaEnvio('ok');
    } catch {
      setBajaEnvio('error');
    }
  };

  const handleAlta = async () => {
    setBajaEnvio('loading');
    try {
      const token = localStorage.getItem('trastero_token');
      const res = await fetch(`${API_URL}/api/auth/alta`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error();
      setBajaPendiente(false);
      setBajaModal(false);
    } catch {
      setBajaEnvio('error');
    }
  };

  const data = isEditing ? draft : profileData;

  return (
    <PageWrapper>
      <Helmet>
        <title>{user?.name ? `${user.name} · Mi Perfil` : 'Mi Perfil · Trastero'}</title>
        <meta name="description" content="Gestiona tus datos personales, dirección y preferencias de tu cuenta en Trastero." />
      </Helmet>

      {/* ── HEADER ── */}
      <HeaderCard bg={bg} border={acc + '55'}>
        <UserInfo>
          <div>
            <AvatarWrapper>
              <AvatarImg src={user.avatar} alt={user.name} accent={acc} />
              {isEditing && (
                <>
                  <input
                    type="file" accept="image/*" id="avatarInput"
                    style={{ display: 'none' }}
                    onChange={handleAvatarChange}
                  />
                  <AvatarEditOverlay htmlFor="avatarInput">
                    {avatarUploading ? '⏳' : '📷'}
                  </AvatarEditOverlay>
                </>
              )}
            </AvatarWrapper>
            {isEditing && avatarOpciones.length > 0 && (
              <AvatarPresetGrid>
                {avatarOpciones.map(({ seed, dataUri }) => (
                  <AvatarPresetBtn key={seed} onClick={() => handlePresetAvatar(seed)} title={seed}>
                    <img src={dataUri} alt={seed} width={44} height={44} style={{ borderRadius: '50%', display: 'block' }} />
                  </AvatarPresetBtn>
                ))}
              </AvatarPresetGrid>
            )}
          </div>
          <UserMeta>
            <UserName bg={bg}>{data.nombre || user.name}</UserName>
            <UserEmail bg={bg}>{user.email}</UserEmail>
            {isEditing ? (
<div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}>
                  <span style={{ fontSize: 15 }}>🏠</span>
                  <TooltipWrap data-tooltip="Nombre público de tu trastero, visible en la página principal.">
                    <Input type="text" value={draftTrastero}
                      onChange={e => { setDraftTrastero(e.target.value); setTrasteroError(''); }}
                      placeholder="Nombre de tu trastero"
                      editing={true} bg={bg} accent={acc}
                      style={{ width: 180, padding: '4px 10px', fontSize: 13 }} />
                  </TooltipWrap>
                </div>
                {trasteroError && (
                  <p style={{ color: '#e74c3c', fontSize: 12, marginTop: 4, marginLeft: 21 }}>{trasteroError}</p>
                )}
              </div>
            ) : trasteroNombre ? (
              <TipoBadge accent={acc} style={{ fontSize: 13, width: 'fit-content' }}>
                🏠 {trasteroNombre}
              </TipoBadge>
            ) : null}
            <HeaderActions>
              {isEditing ? (
                <>
                  <Btn variant="primary" accent={acc} onClick={handleSave}>Guardar</Btn>
                  <Btn variant="ghost" bg={bg} onClick={handleCancel}>Cancelar</Btn>
                </>
              ) : (
                <>
                  <Btn variant="primary" accent={acc} onClick={handleEdit}>✏️ Editar perfil</Btn>
                  <Btn variant="danger" onClick={handleLogout}>Salir</Btn>
                  <Btn
                    variant="ghost" bg={bg}
                    style={{ fontSize: 12, opacity: bajaPendiente ? 1 : 0.6, color: bajaPendiente ? '#f59e0b' : undefined }}
                    title={bajaPendiente
                      ? 'Tu cuenta está pendiente de eliminación. Pulsa para reactivarla.'
                      : 'Solicitar la baja de tu cuenta. Tendrás 48 h para cancelarla contactando con soporte.'}
                    onClick={() => { setBajaModal(true); setBajaEnvio('idle'); }}
                  >
                    {bajaPendiente ? '⚠️ Dar de alta' : 'Dar de baja'}
                  </Btn>
                </>
              )}
            </HeaderActions>
          </UserMeta>
        </UserInfo>

        {/* ── RANKING ── */}
        <RankingPanel>
          <RankBadge bg={bg} border={acc + '33'}>
            <RankIcon>📦</RankIcon>
            <RankInfo><RankLabel bg={bg}>Vendidos</RankLabel><RankValue accent={acc}>{ranking.vendidos}</RankValue></RankInfo>
          </RankBadge>
          <RankBadge bg={bg} border="#e74c3c55">
            <RankIcon>⚠️</RankIcon>
            <RankInfo><RankLabel bg={bg}>Reclamaciones</RankLabel><RankValue accent="#e74c3c">{ranking.reclamaciones}</RankValue></RankInfo>
          </RankBadge>
          <RankBadge bg={bg} border="#f39c1255">
            <RankIcon>↩️</RankIcon>
            <RankInfo><RankLabel bg={bg}>Devueltos</RankLabel><RankValue accent="#f39c12">{ranking.devueltos}</RankValue></RankInfo>
          </RankBadge>
          <RankBadge bg={bg} border="#27ae6055">
            <RankIcon>👍</RankIcon>
            <RankInfo><RankLabel bg={bg}>Recomendado</RankLabel><RankValue accent="#27ae60">{ranking.recomendados}</RankValue></RankInfo>
          </RankBadge>
        </RankingPanel>
      </HeaderCard>

      {/* ── CUERPO ── */}
      <BodyGrid>

        {/* ── DATOS PERSONALES ── */}
        <Card bg={bg} border={acc + '44'}>
          <SectionTitle accent={acc}>Datos personales</SectionTitle>
          <DatosGrid>
            <div>
              <FormGroup>
                <Label bg={bg} htmlFor="nombre">Nombre completo</Label>
                <TooltipWrap data-tooltip="Tu nombre completo, como aparecerá en tus anuncios.">
                  <Input id="nombre" name="nombre" type="text" value={data.nombre}
                    onChange={handleChange} placeholder="Tu nombre completo"
                    editing={isEditing} bg={bg} accent={acc} />
                </TooltipWrap>
              </FormGroup>
              <FormGroup>
                <Label bg={bg} htmlFor="telefono">Teléfono</Label>
                <TooltipWrap data-tooltip="Número de contacto visible para compradores interesados.">
                  <Input id="telefono" name="telefono" type="tel" value={data.telefono}
                    onChange={handleChange} placeholder="+34 600 000 000"
                    editing={isEditing} bg={bg} accent={acc} />
                </TooltipWrap>
              </FormGroup>
              <FormGroup>
                <Label bg={bg} htmlFor="tipoUsuario">Tipo de cuenta</Label>
                <TooltipWrap data-tooltip="Persona: cuenta personal. Empresa: cuenta comercial con razón social.">
                  <Select id="tipoUsuario" name="tipoUsuario" value={data.tipoUsuario}
                    onChange={handleChange} editing={isEditing} bg={bg} accent={acc}>
                    <option value="persona">Persona</option>
                    <option value="empresa">Empresa</option>
                  </Select>
                </TooltipWrap>
              </FormGroup>
              {data.tipoUsuario === 'empresa' && (
                <FormGroup>
                  <Label bg={bg} htmlFor="personaContacto">Persona de contacto</Label>
                  <TooltipWrap data-tooltip="Nombre del responsable de la empresa para el contacto.">
                    <Input id="personaContacto" name="personaContacto" type="text" value={data.personaContacto}
                      onChange={handleChange} placeholder="Nombre del responsable"
                      editing={isEditing} bg={bg} accent={acc} />
                  </TooltipWrap>
                </FormGroup>
              )}

              <div style={{ marginTop: 8 }}>
                <Btn variant="primary" accent={acc} type="button" onClick={() => { setPassModal(true); setPassActual(''); setPassNueva(''); setPassNueva2(''); setPassError(''); setPassOk(false); }}>
                  🔑 Cambiar contraseña
                </Btn>
              </div>

            </div>
            <ImgSlot style={{ position: 'relative' }}>
              <ImgSlotImg
                src={buildBackendImgUrl(trasteroImgUrl) || DEFAULT_IMG}
                alt="Logo del trastero" accent={acc}
                style={{ opacity: trasteroImgUploading ? 0.5 : 1 }} />
              {trasteroImgUploading && (
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: 13, color: '#fff', fontWeight: 600,
                  background: 'rgba(0,0,0,0.4)', borderRadius: 10 }}>
                  Subiendo…
                </div>
              )}
              {isEditing && !trasteroImgUploading && (
                <>
                  <input type="file" accept="image/*" id="trasteroImgInput"
                    style={{ display: 'none' }} onChange={handleImgChange} />
                  <ImgSlotLabel htmlFor="trasteroImgInput" bg={bg}>Cambiar imagen</ImgSlotLabel>
                </>
              )}
            </ImgSlot>
          </DatosGrid>
        </Card>

        {/* ── DIRECCIÓN ── */}
        <Card bg={bg} border={acc + '44'}>
          <SectionTitle accent={acc}>Dirección</SectionTitle>
          <TwoCol>
            <FormGroup>
              <Label bg={bg} htmlFor="tipoVia">Tipo de vía</Label>
              <TooltipWrap data-tooltip="Calle, Avenida, Plaza, Carretera, etc.">
                <Select id="tipoVia" name="tipoVia" value={data.tipoVia}
                  onChange={handleChange} editing={isEditing} bg={bg} accent={acc}>
                  {TIPOS_VIA.map(t => <option key={t} value={t}>{t}</option>)}
                </Select>
              </TooltipWrap>
            </FormGroup>
            <FormGroup>
              <Label bg={bg} htmlFor="numero">Número</Label>
              <TooltipWrap data-tooltip="Número de portal (ej: 12).">
                <Input id="numero" name="numero" type="text" value={data.numero}
                  onChange={handleChange} placeholder="12"
                  editing={isEditing} bg={bg} accent={acc} />
              </TooltipWrap>
            </FormGroup>
          </TwoCol>
          <FormGroup>
            <Label bg={bg} htmlFor="nombreVia">Nombre de la vía</Label>
            <TooltipWrap data-tooltip="Nombre de la calle, avenida o plaza (ej: Gran Vía).">
              <Input id="nombreVia" name="nombreVia" type="text" value={data.nombreVia}
                onChange={handleChange} placeholder="Gran Vía"
                editing={isEditing} bg={bg} accent={acc} />
            </TooltipWrap>
          </FormGroup>
          <TwoCol>
            <FormGroup>
              <Label bg={bg} htmlFor="piso">Piso</Label>
              <TooltipWrap data-tooltip="Planta o piso (ej: 3, bajo, entresuelo).">
                <Input id="piso" name="piso" type="text" value={data.piso}
                  onChange={handleChange} placeholder="3º"
                  editing={isEditing} bg={bg} accent={acc} />
              </TooltipWrap>
            </FormGroup>
            <FormGroup>
              <Label bg={bg} htmlFor="puerta">Puerta</Label>
              <TooltipWrap data-tooltip="Letra o número de puerta (ej: A, B, 1, 2).">
                <Input id="puerta" name="puerta" type="text" value={data.puerta}
                  onChange={handleChange} placeholder="B"
                  editing={isEditing} bg={bg} accent={acc} />
              </TooltipWrap>
            </FormGroup>
          </TwoCol>
          <TwoCol>
            <FormGroup>
              <Label bg={bg} htmlFor="codigoPostal">Código Postal</Label>
              <TooltipWrap data-tooltip="5 dígitos del código postal (ej: 28001).">
                <Input id="codigoPostal" name="codigoPostal" type="text" value={data.codigoPostal}
                  onChange={handleChange} placeholder="28001"
                  editing={isEditing} bg={bg} accent={acc} />
              </TooltipWrap>
            </FormGroup>
            <FormGroup>
              <Label bg={bg} htmlFor="pais">País</Label>
              <TooltipWrap data-tooltip="País donde se ubica tu trastero.">
                <Input id="pais" name="pais" type="text" value={data.pais}
                  onChange={handleChange} placeholder="España"
                  editing={isEditing} bg={bg} accent={acc} />
              </TooltipWrap>
            </FormGroup>
          </TwoCol>
        </Card>
      </BodyGrid>

      {/* ── MODAL CAMBIAR CONTRASEÑA ── */}
      {passModal && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 9000, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: bg || '#1a1a2e', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 14, padding: '32px 28px', maxWidth: 420, width: '100%' }}>
            <p style={{ fontSize: 18, fontWeight: 700, color: '#fff', marginBottom: 20 }}>🔑 Cambiar contraseña</p>
            {passOk ? (
              <>
                <p style={{ color: '#2ecc71', fontSize: 14, marginBottom: 20 }}>✅ Contraseña actualizada correctamente.</p>
                <Btn variant="primary" accent={acc} onClick={() => setPassModal(false)}>Cerrar</Btn>
              </>
            ) : (
              <form onSubmit={async e => {
                e.preventDefault();
                setPassError('');
                if (!isPasswordValid(passNueva)) { setPassError('La nueva contraseña no cumple los requisitos mínimos de seguridad'); return; }
                if (passNueva !== passNueva2) { setPassError('Las contraseñas nuevas no coinciden'); return; }
                setPassLoading(true);
                try {
                  const token = localStorage.getItem('trastero_token');
                  const res = await fetch(`${API_URL}/api/auth/cambiar-password`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                    body: JSON.stringify({ passwordActual: passActual, passwordNueva: passNueva }),
                  });
                  const data = await res.json();
                  if (!res.ok) { setPassError(data.error || 'Error'); return; }
                  setPassOk(true);
                } catch { setPassError('No se pudo conectar con el servidor'); }
                finally { setPassLoading(false); }
              }}>
                {[
                  { label: 'Contraseña actual', val: passActual, set: setPassActual, show: showPassA, setShow: setShowPassA },
                  { label: 'Nueva contraseña',  val: passNueva,  set: setPassNueva,  show: showPassN, setShow: setShowPassN },
                  { label: 'Repetir nueva',      val: passNueva2, set: setPassNueva2, show: showPassN2,setShow: setShowPassN2 },
                ].map(({ label, val, set, show, setShow }) => (
                  <div key={label} style={{ marginBottom: 16 }}>
                    <Label bg={bg}>{label}</Label>
                    <div style={{ position: 'relative' }}>
                      <Input type={show ? 'text' : 'password'} value={val} onChange={e => set(e.target.value)}
                        placeholder="••••••••" editing={true} bg={bg} accent={acc} style={{ paddingRight: 44 }} />
                      <button type="button" onClick={() => setShow(v => !v)}
                        style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,0.4)', fontSize: 16, padding: 0 }}>
                        {show ? '🙈' : '👁️'}
                      </button>
                    </div>
                    {label === 'Nueva contraseña' && val && (
                      <PasswordChecklist password={val} color="#fff" />
                    )}
                  </div>
                ))}
                {passError && <p style={{ color: '#e74c3c', fontSize: 13, marginBottom: 12 }}>{passError}</p>}
                <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                  <Btn variant="ghost" bg={bg} type="button" onClick={() => setPassModal(false)} style={{ flex: 1 }}>Cancelar</Btn>
                  <Btn variant="primary" accent={acc} type="submit"
                    disabled={passLoading || !isPasswordValid(passNueva)} style={{ flex: 1 }}>
                    {passLoading ? 'Guardando...' : 'Guardar'}
                  </Btn>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* ── MODAL DAR DE BAJA ── */}
      {bajaModal && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 9000,
          background: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '16px',
        }}>
          <div style={{
            background: bg || '#1a1a2e',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 14, padding: '32px 28px',
            maxWidth: 440, width: '100%',
          }}>
            {bajaPendiente && bajaEnvio !== 'ok' ? (
              /* ── Vista: cuenta ya en baja_pendiente → ofrecer reactivar ── */
              <>
                <p style={{ fontSize: 18, fontWeight: 700, color: '#f59e0b', marginBottom: 12 }}>
                  ⚠️ Cuenta pendiente de eliminación
                </p>
                <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.75)', lineHeight: 1.6, marginBottom: 24 }}>
                  Tu cuenta está en proceso de baja. Si fue un error o has cambiado de opinión,
                  pulsa <strong>Reactivar cuenta</strong> para volver a activarla.
                </p>
                {bajaEnvio === 'error' && (
                  <p style={{ fontSize: 13, color: '#ef4444', marginBottom: 12 }}>
                    Error al reactivar. Inténtalo de nuevo.
                  </p>
                )}
                <div style={{ display: 'flex', gap: 12 }}>
                  <Btn variant="ghost" bg={bg} onClick={() => setBajaModal(false)} style={{ flex: 1 }}>
                    Cerrar
                  </Btn>
                  <Btn
                    variant="primary" accent={acc}
                    onClick={handleAlta}
                    disabled={bajaEnvio === 'loading'}
                    style={{ flex: 1 }}
                  >
                    {bajaEnvio === 'loading' ? 'Procesando...' : 'Reactivar cuenta'}
                  </Btn>
                </div>
              </>
            ) : bajaEnvio === 'ok' ? (
              /* ── Vista: confirmación tras solicitar baja ── */
              <>
                <p style={{ fontSize: 18, fontWeight: 700, color: '#fff', marginBottom: 12 }}>
                  Solicitud registrada
                </p>
                <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6, marginBottom: 24 }}>
                  Tu solicitud de baja ha sido registrada. Tienes <strong style={{ color: '#f59e0b' }}>48 horas</strong> para
                  solicitar la reactivación escribiendo a{' '}
                  <a href="mailto:soporte@trasteroweb.es" style={{ color: acc }}>soporte@trasteroweb.es</a>.
                  Pasado ese plazo, la cuenta será eliminada por el equipo de mantenimiento.
                </p>
                <Btn variant="primary" accent={acc} onClick={() => setBajaModal(false)}>Cerrar</Btn>
              </>
            ) : (
              /* ── Vista: confirmación de baja ── */
              <>
                <p style={{ fontSize: 18, fontWeight: 700, color: '#ef4444', marginBottom: 12 }}>
                  ¿Dar de baja tu cuenta?
                </p>
                <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.75)', lineHeight: 1.6, marginBottom: 8 }}>
                  Al confirmar, tu cuenta quedará marcada como <strong>pendiente de eliminación</strong>.
                </p>
                <ul style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, paddingLeft: 18, marginBottom: 24 }}>
                  <li>Tienes <strong style={{ color: '#f59e0b' }}>48 horas</strong> para cancelar la baja.</li>
                  <li>Para reactivarla, escribe a <a href="mailto:soporte@trasteroweb.es" style={{ color: acc }}>soporte@trasteroweb.es</a>.</li>
                  <li>Pasado el plazo, todos tus datos y anuncios serán eliminados permanentemente.</li>
                </ul>
                {bajaEnvio === 'error' && (
                  <p style={{ fontSize: 13, color: '#ef4444', marginBottom: 12 }}>
                    Error al procesar la solicitud. Inténtalo de nuevo.
                  </p>
                )}
                <div style={{ display: 'flex', gap: 12 }}>
                  <Btn variant="ghost" bg={bg} onClick={() => setBajaModal(false)} style={{ flex: 1 }}>
                    Cancelar
                  </Btn>
                  <Btn
                    variant="danger"
                    onClick={handleBaja}
                    disabled={bajaEnvio === 'loading'}
                    style={{ flex: 1 }}
                  >
                    {bajaEnvio === 'loading' ? 'Procesando...' : 'Confirmar baja'}
                  </Btn>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </PageWrapper>
  );
}

export default Profile;